import { motion } from 'framer-motion';

interface TextSectionProps {
  eyebrow?: string;
  title?: string;
  body: string;
  className?: string;
}

export function TextSection({
  eyebrow,
  title,
  body,
  className = '',
}: TextSectionProps) {
  return (
    <motion.section
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className={`max-w-3xl space-y-4 ${className}`}
    >
      {eyebrow ? (
        <p className="label">
          {eyebrow}
        </p>
      ) : null}
      {title ? (
        <h2 className="heading-section">
          {title}
        </h2>
      ) : null}
      <div
        className="body space-y-4 [&_strong]:font-medium [&_strong]:text-black"
        dangerouslySetInnerHTML={{ __html: body }}
      />
    </motion.section>
  );
}
